import { ReactElement } from 'react';

import { appendTestableCustomAttribute } from '@dreryk/react-components';

import { VisitSettlementStatusIcon } from '~libs.shared.visit-settlement';

type AppointmentsTimetableEventSettlementStatusProps = {
   visitId: number | undefined;
   appointmentId: number;
};

export const AppointmentsTimetableEventSettlementStatus = (
   props: AppointmentsTimetableEventSettlementStatusProps
): ReactElement => {
   return (
      <span {...appendTestableCustomAttribute('calendarEventSettlementStatus', props.visitId ? 'available' : 'none')}>
         <VisitSettlementStatusIcon appointmentId={props.appointmentId} />
      </span>
   );
};
